<template>
    <div class="auth-expired">
        <div class="modal">
        <i v-if="submitStatus != 'SUCCESS'" class="i-expired"></i>
        <label v-if="submitStatus != 'SUCCESS'">Sessão Expirada</label>
        <label v-if="submitStatus != 'SUCCESS'">Verificamos que esteve em inatividade por mais de 15 minutos. Por segurança a sua sessão foi terminada. </label>
        <fyi-button
            v-if="!showLogin && submitStatus != 'SUCCESS'"
            :className="'default login-bt'"
            :label="'Iniciar sessão'"
            :onclick="() => showLogin = true"
        />
        <div v-if="showLogin" class="login-form">
            <fyi-email
                v-if="submitStatus != 'SUCCESS'"
                v-bind:value="emailOmitted"
                :alias="'email'"
                :label="$t('email')"
                :placeholder="$t('email_placeholder')"
                :disabled="true"
                :required="true"
                :inputError="false"
            />
            <fyi-password
                v-if="submitStatus != 'SUCCESS'"
                v-bind:value="password"
                v-on:input-password="password = $event"
                :alias="'password'"
                :label="$t('password')"
                :show="true"
                :placeholder="'● ● ● ● ● ●'"
                :disabled="false"
                :required="true"
                :inputError="false"
                @submit="doLogin"
            />
            <fyi-button
                v-if="submitStatus != 'SUCCESS'"
                :className="'default login-bt'"
                :loading="submitStatus=='PENDING'"
                :label="'Iniciar sessão'"
                :onclick="doLogin"
            />
            <div v-if="submitStatus == 'SUCCESS'" class="step-success">
				<div class="animation"></div>
				<label>{{$t('login_success')}}</label>
			</div>
            <label v-if="errorMessage != ''" class="error-label">
				{{errorMessage}}
			</label>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name:"AuthExpired",
    data(){
        return{
            showLogin: false,
            email: this.$store.getters.auth.user.email,
            password: '',
            errorMessage: '',
            submitStatus: 'READY'
        }
    },
    watch:{
        submitStatus(_new, _old){
			if(_new == "ERROR"){
				this.errorMessage = this.$t('error_1')
			}else if(_new == "OTP_ERROR"){
				this.errorMessage = this.$t('error_2')
			}else{
				this.errorMessage = "";
			}
		}
    },
    computed:{
        emailOmitted(){
            let email = this.$store.getters.auth.user.email[0]
            let splitt = this.$store.getters.auth.user.email.split("@")
            for (let i = 1; i < splitt[0].length; i++) {
                email += "*"
            }
            email+="@"
            for (let i = 1; i < splitt[1].length; i++) {
                email += "*"
            }

            return email + this.$store.getters.auth.user.email[this.$store.getters.auth.user.email.length - 1]
        }
    },
    methods:{
		...mapActions([
			"login",
            "revoke"
	  ]),
      doLogin(){
        let _this = this;
        const {email, password} = this;
        this.submitStatus = "PENDING";
        this.login({ email, password })
            .then((response) => {
                this.submitStatus = "SUCCESS";
                setTimeout(function(){
                    document.querySelector(".step-success .animation").innerHTML = "";
                    bodymovin.loadAnimation({
                        container: document.querySelector('.step-success .animation'),
                        animationData: {"v":"5.6.1","fr":60,"ip":0,"op":93,"w":90,"h":90,"nm":"Cashback Activation Animation","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"check","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[46,46,0],"ix":2},"a":{"a":0,"k":[-64.139,-543.26,0],"ix":1},"s":{"a":0,"k":[39.706,39.706,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.841,0.133],[-0.919,-0.115]],"o":[[0,0],[0.059,0.133],[-1.115,-0.102]],"v":[[-24.839,-568.19],[-76.231,-518.331],[-103.417,-545.583]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":62,"s":[0],"e":[100]},{"t":63}],"ix":4},"w":{"a":0,"k":18,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.673],"y":[1]},"o":{"x":[0.34],"y":[0]},"t":62,"s":[0],"e":[100]},{"i":{"x":[0.477],"y":[0.892]},"o":{"x":[0.061],"y":[0]},"t":63,"s":[100],"e":[0]},{"t":88}],"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"gr","it":[{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":13,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":1,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":935,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"bg","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[45,45,0],"ix":2},"a":{"a":0,"k":[16.233,24.733,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.385,0.385,0.663],"y":[0.996,0.996,-36.691]},"o":{"x":[0.369,0.369,0.296],"y":[0,0,0]},"t":47,"s":[0,0,100],"e":[156.367,156.367,100]},{"i":{"x":[0.558,0.558,0.812],"y":[1.011,1.011,1]},"o":{"x":[0.239,0.239,0.427],"y":[-0.017,-0.017,33.575]},"t":74,"s":[156.367,156.367,100],"e":[128.636,128.636,100]},{"t":93}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[15.317,0],[0,-15.317],[-15.317,0],[0,15.317]],"o":[[-15.317,0],[0,15.317],[15.317,0],[0,-15.317]],"v":[[0,-27.733],[-27.733,0],[0,27.733],[27.733,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[16.233,24.733],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":2400,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"progress","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[45,45,0],"ix":2},"a":{"a":0,"k":[111.5,111.5,0],"ix":1},"s":{"a":0,"k":[47,47,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-46.392,0],[0,46.392],[46.392,0],[0,-46.392]],"o":[[46.392,0],[0,-46.392],[-46.392,0],[0,46.392]],"v":[[0,84],[84,0],[0,-84],[-84,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":17,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[111.5,111.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.783],"y":[0]},"t":0,"s":[100],"e":[0]},{"t":53}],"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":-34,"op":967,"st":180,"bm":0}],"markers":[]},
                        renderer: 'svg',
                        loop: false,
                        autoplay: true
                    });
                    setTimeout(function(){
                        //_this.$router.go()
                        _this.$parent.expired = false;
                        _this.$parent.instateSecurityMeasurement();
                    }, 2000)
                }, 100)

            })
            .catch(err => {
                console.log(err);
                this.submitStatus = "ERROR";
            });
      }
    },
    mounted(){
        this.revoke();
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/layout/expired";
</style>